import lookupValidator from 'ember-changeset-validations'
import type { EmberChangeset } from 'ember-changeset'
import { Changeset } from 'ember-changeset'
import { editClassValidator } from 'teacher-ui-client/school-class/validator'
import type SchoolClass from 'teacher-ui-client/models/school-class'
import type Student from 'teacher-ui-client/models/student'
import { SubscriptionType } from 'teacher-ui-client/subscription-type/subscription-types'
import type Teacher from 'teacher-ui-client/models/teacher'
import type { Identifiable } from 'teacher-ui-client/components/data-operations/table/records-selector'

export interface FromClassRow extends EmberChangeset, Identifiable {
  id: string
  originalName: string
  name: string
  students: Student[]
  teachers: Teacher[]
  studentCount: number
  teacherNames: string
  gamesAccess: boolean
  playroomAccess: boolean
  mathseedsPrimeAccess: boolean
  backgroundMusicDisabled: boolean
}

export function schoolClassToChangeset(
  targetSubscriptionType: SubscriptionType,
  schoolClass: SchoolClass,
): FromClassRow {
  const newSchoolData = {
    id: schoolClass.id,
    originalName: schoolClass.name,
    name: schoolClass.name,
    students: schoolClass.students,
    teachers: schoolClass.teachers,
    teacherNames: schoolClass.teacherNames.join(', '),
    studentCount: schoolClass.studentCount,
    gamesAccess: schoolClass.gamesAccess,
    playroomAccess: schoolClass.playroomAccess,
    backgroundMusicDisabled: schoolClass.backgroundMusicDisabled,
    mathseedsPrimeAccess: targetSubscriptionType === SubscriptionType.Maths, // default true for new maths classes
  }
  return Changeset(newSchoolData, lookupValidator(editClassValidator), editClassValidator) as unknown as FromClassRow
}
